import React from 'react'

import { t, Trans } from 'src/translations'

import {
  CakeIcon,
  WorkOutlineIcon,
  GroupIcon
} from '@toasttab/buffet-pui-icons'
import classnames from 'classnames'

import Image from 'src/shared/components/common/Image'
import { DropDownOption } from 'src/shared/components/common/dropdown/DropDownOption'

import DropDown from 'shared/components/common/dropdown'

type Props = {
  formState: object
  occasion: string
  setOccasion: (occasion: string) => void
}

type Option = {
  label: string
  icon: React.JSX.Element
  displayName: string
}

export const OPTIONS = (t: any) => {
  return getOptions(t)
}

function getOptions(t: any): Option[] {
  return [
    {
      label: 'Birthday',
      icon: <CakeIcon accessibility='decorative' />,
      displayName: t('occasion-selector.option.birthday')
    },
    {
      label: 'Anniversary',
      icon: <Image alt='' src='/icons/anniversary.svg' />,
      displayName: t('occasion-selector.option.anniversary')
    },
    {
      label: 'Date',
      icon: <Image alt='' src='/icons/date.svg' />,
      displayName: t('occasion-selector.option.date')
    },
    {
      label: 'Business',
      icon: <WorkOutlineIcon accessibility='decorative' />,
      displayName: t('occasion-selector.option.business')
    },
    {
      label: 'Reunion',
      icon: <GroupIcon accessibility='decorative' />,
      displayName: t('occasion-selector.option.reunion')
    },
    {
      label: 'Celebration',
      icon: <Image alt='' src='/icons/celebration.svg' />,
      displayName: t('occasion-selector.option.celebration')
    }
  ]
}

const getIconForOccasion = (occasion: string) => {
  const option = OPTIONS(t).find((opt) => opt.label === occasion)
  return option ? option.icon : null
}

const OccasionSelector = ({ occasion, setOccasion }: Props) => {
  const dropDownLabel = (
    <div className='selected'>
      {getIconForOccasion(occasion) || (
        <span className='placeholder'>{t('occasion-selector.occasion')}</span>
      )}{' '}
      {occasion}
    </div>
  )

  return (
    <div className='occasionSelector'>
      <div className='dropDownWrapper'>
        <DropDown
          testId='occasion-selector'
          label={dropDownLabel}
          ariaLabel={t('occasion-selector.select-an-occasion')}
          withBorder
          leftAligned
        >
          {({ close, ref }) =>
            OPTIONS(t).map((opt) => (
              <DropDownOption
                key={opt.label}
                onSelect={(e) => {
                  e.preventDefault()
                  e.stopPropagation()
                  setOccasion(opt.label)
                  close()
                  ref?.current?.focus()
                }}
                onClose={close}
                className={classnames('option', {
                  selected: occasion === opt.label
                })}
                testId={`occasion-option-${opt.label}`}
              >
                <Trans
                  i18nKey='occasion-selector.icon-and-option'
                  components={{ Icon: opt.icon }}
                  values={{ occasionName: opt.displayName }}
                />
              </DropDownOption>
            ))
          }
        </DropDown>
      </div>
    </div>
  )
}

export default OccasionSelector
